const _apiQueue = [];
let _apiActive = 0;
const _apiMaxConcurrent = 4;

/* /api/airtable requires a Clerk bearer (see api/airtable.js). OutlineView installs
 * window.__clerkGetToken before initOutline, so the getter normally exists by the
 * time anything here fires — the brief wait covers any early caller (mirrors
 * services/_api.js). Resolves to 'Bearer <jwt>' or null (request goes out
 * unauthenticated and the server 401s). */
async function _authHeader() {
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try {
        const t = await window.__clerkGetToken();
        if (t) return 'Bearer ' + t;
      } catch (e) { /* signed out or Clerk not ready */ }
      return null;
    }
    await new Promise(r => setTimeout(r, 150));
  }
  return null;
}

function _apiFlush() {
  while (_apiActive < _apiMaxConcurrent && _apiQueue.length > 0) {
    const job = _apiQueue.shift();
    _apiActive++;
    _apiExec(job.tbl, job.qs, job.cb, 0);
  }
}

function _apiExec(tbl, qs, cb, retries) {
  _authHeader().then(function(auth) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/airtable', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (auth) xhr.setRequestHeader('Authorization', auth);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      _apiActive--;
      if (xhr.status === 429 && retries < 3) {
        setTimeout(function() { _apiActive++; _apiExec(tbl, qs, cb, retries + 1); }, 500 * (retries + 1));
      } else {
        cb(xhr.status === 200 ? JSON.parse(xhr.responseText) : null);
        _apiFlush();
      }
    };
    xhr.send(JSON.stringify({ method: 'GET', tbl: tbl, qs: qs || '' }));
  });
}

export function apiGet(tbl, qs, cb) {
  _apiQueue.push({ tbl: tbl, qs: qs, cb: cb });
  _apiFlush();
}

export function apiDeleteBatch(tbl, ids, cb) {
  if (!ids.length) { cb(true); return; }
  const batches = [];
  for (let i = 0; i < ids.length; i += 10) batches.push(ids.slice(i, i + 10));
  let bIdx = 0;
  function nextBatch() {
    if (bIdx >= batches.length) { cb(true); return; }
    const batch = batches[bIdx++];
    _authHeader().then(function(auth) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/airtable', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      if (auth) xhr.setRequestHeader('Authorization', auth);
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) return;
        if (xhr.status === 200 || xhr.status === 204) nextBatch();
        else cb(false);
      };
      xhr.send(JSON.stringify({ method: 'DELETE', tbl: tbl, batchIds: batch }));
    });
  }
  nextBatch();
}

export function apiDelete(tbl, id, cb) {
  _authHeader().then(function(auth) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/airtable', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (auth) xhr.setRequestHeader('Authorization', auth);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      cb(xhr.status === 200 || xhr.status === 204);
    };
    xhr.send(JSON.stringify({ method: 'DELETE', tbl: tbl, id: id }));
  });
}

export function apiPost(tbl, fields, cb) {
  _authHeader().then(function(auth) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/airtable', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (auth) xhr.setRequestHeader('Authorization', auth);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (xhr.status !== 200) console.log('apiPost failed:', xhr.status, xhr.responseText.slice(0, 200));
      cb(xhr.status === 200, xhr.status === 200 ? JSON.parse(xhr.responseText) : null);
    };
    xhr.send(JSON.stringify({ method: 'POST', tbl: tbl, fields: fields }));
  });
}

export function apiPostBatch(tbl, records, cb) {
  const batches = [];
  for (let i = 0; i < records.length; i += 10) batches.push(records.slice(i, i + 10));
  let results = [];
  let bIdx = 0;
  function next() {
    if (bIdx >= batches.length) { cb(true, results); return; }
    const batch = batches[bIdx++];
    _authHeader().then(function(auth) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/airtable', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      if (auth) xhr.setRequestHeader('Authorization', auth);
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) return;
        if (xhr.status !== 200) { cb(false, results); return; }
        results = results.concat(JSON.parse(xhr.responseText).records || []);
        next();
      };
      xhr.send(JSON.stringify({ method: 'POST', tbl: tbl, records: batch }));
    });
  }
  next();
}

export function apiPatch(tbl, id, fields, cb) {
  _authHeader().then(function(auth) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/airtable', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (auth) xhr.setRequestHeader('Authorization', auth);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (xhr.status !== 200) console.log('apiPatch failed:', xhr.status, xhr.responseText.slice(0, 200));
      cb(xhr.status === 200, xhr.status === 200 ? JSON.parse(xhr.responseText) : null);
    };
    xhr.send(JSON.stringify({ method: 'PATCH', tbl: tbl, id: id, fields: fields }));
  });
}
